import { Flex, Slider, Text, Title } from '@mantine/core';
import NumberFlow from '@number-flow/react';
import { EditFormData } from './types';

interface MaterialSectionProps {
	formData: EditFormData;
	onInput: (key: keyof EditFormData, value: string | number | boolean | null) => void;
}

/**
 * Material and contamination section
 */
export const MaterialSection: React.FC<MaterialSectionProps> = ({ formData, onInput }) => {
	return (
		<Flex direction="column" w="100%" pb="xl" gap="sm">
			<Flex px="md" align="center" justify="space-between" w="100%">
				<Title order={2}>Material Details</Title>
			</Flex>

			<Flex direction="row" justify="space-between" align="center" px="md" gap="md">
				<Text size="sm" span fw={500}>
					Amount
				</Text>
				<Text size="lg" mt={-5} fw={600}>
					<NumberFlow value={formData.contaminationAmount || 0} suffix="%" />
				</Text>
			</Flex>
			<Slider
				color="blue"
				marks={[
					{ value: 20, label: '20%' },
					{ value: 50, label: '50%' },
					{ value: 80, label: '80%' },
				]}
				label={null}
				onChange={(value) => onInput('contaminationAmount', value)}
				value={formData.contaminationAmount || 0}
				step={5}
				min={0}
				max={100}
				thumbSize={28}
				mx="md"
			/>
		</Flex>
	);
};
